import React, { useState, useEffect } from "react";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import ExcelJS from "exceljs";
import { Formik, Form, Field } from "formik";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
const MultiClearenceExistingGvpInnerGvpReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const {data,formatDate,shiftName} = location.state;
  const navigate = useNavigate();
  const [gvpList, setGvpList] = useState(data);
  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width:'100px'
    },
    {
      name: "Zone",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"] || "N/A" }
        </span>
      ),
      sortable: true,
    },
    {
      name: "Circle",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Ward",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["wardName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "GVP Code",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["collectionPointCode"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "GVP Name",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["collectionPointName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Latitude",
      selector: (row) => (
        <span
        // style={{ color: "blue" }}
        >
          {row["latitude"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Longitude",
      selector: (row) => (
        <span
        // style={{ color: "blue" }}
        > {row["longitude"] || "N/A"}</span>
      ),
      sortable: true,
    },
  ];

  
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = 
    `Existing GVPs Wise Multiple Clearance Report on ${formatDate?formattedDate(formatDate):getCurrentISTDate()} - ${shiftName} - (at ${getCurrentDateTime1()})`;
    

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 7); 
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 3 && colNumber <= 7) {
            // Apply styles to download date and time cells
            cell.font = boldFont;
            cell.alignment = { horizontal: "center" };
        }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 7);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 3 && colNumber <= 7) {
            // Apply styles to cumulative heading report cells
            cell.font = boldFont;
            cell.alignment = { horizontal: "center" };
        }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Zone",
        "Circle",
        "Ward",
        "GVP Code",
        "GVP Name",
        "Latitude",
        "Longitude",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" }; // Left align the cell content
        if (colNumber >= 1 && colNumber <= 12) {
            // Apply background color only to specific cells
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" } // Red background color
            };
        }
    });

    // Add data rows
    gvpList.forEach((item, index) => {
        worksheet.addRow([
            index + 1,
            item.zoneName?? "N/A",
            item.circleName?? "N/A",
            item.wardName?? "N/A",
            item.collectionPointCode?? "N/A",
            item.collectionPointName?? "N/A",
            item.latitude?? "N/A",
            item.longitude?? "N/A",
        ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 1 && colNumber <= 12) {
                // Align the columns from 1 to 4 to the left
                cell.alignment = { horizontal: "left" };
            } else {
                // Align the rest of the columns to the center
                cell.alignment = { horizontal: "center" };
            }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
        { width: 5 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Existing GVPs Wise Multi Clearace Inner Existing Report.xlsx";
    a.click();
    URL.revokeObjectURL(url);
};
const filterFields = {
  searchCircle: "",
  searchCollectionPointCode: "",
  searchCollectionPointName: "",
};
const searchReportedAtVehicleHandler = (values) => {
  const termCircle = values.searchCircle
    ? values.searchCircle.toLowerCase()
    : "";
    const termCollectionPointCode = values.searchCollectionPointCode
    ? values.searchCollectionPointCode.toLowerCase()
    : "";
    const termCollectionPointName = values.searchCollectionPointName
    ? values.searchCollectionPointName.toLowerCase()
    : "";

  const filteredData = data.filter((item) => {
    const circleName = item?.circleName ? String(item.circleName).toLowerCase() : "";
    const collectionPointCode = item?.collectionPointCode ? String(item.collectionPointCode).toLowerCase() : "";
    const collectionPointName = item?.collectionPointName ? String(item.collectionPointName).toLowerCase() : "";
    const matchesCircle = !termCircle || circleName.includes(termCircle);
    const matchesCollectionPointCode = !termCollectionPointCode || collectionPointCode.includes(termCollectionPointCode);
    const matchesCollectionPointName = !termCollectionPointName || collectionPointName.includes(termCollectionPointName);
    return (matchesCircle && matchesCollectionPointCode && matchesCollectionPointName);
  
  });
  setGvpList(filteredData);
};
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
           
            <div className="card mt-3">
              <div className="card-body">
              <div className="page-header">
            <div className="d-flex justify-content-between mt-3">
            <Formik initialValues={filterFields}>
                      {({ handleChange, values }) => (
                        <Form>
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchCircle"
                                  placeholder="Search Circle"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCircle: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchGvpCode"
                                  placeholder="Search GVP Code"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCollectionPointCode: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchGvpName"
                                  placeholder="Search GVP Name"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCollectionPointName: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            
                          </div>
                        </Form>
                      )}
                    </Formik>
                    <div className="d-flex">
                      <div>
                      <button className="btn btn-secondary me-2"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
                      </div>
              <div>
              <button
                className="btn btn-excel"
                onClick={downloadAsExcel}
              >
               <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
              </button>
              </div>
             
              </div>
            </div>
            </div>
            
                <div className="top-header">
                  <span>
                    {" "}
                    Existing GVPs Wise Multiple Clearance Report as on {formatDate?formattedDate(formatDate):getCurrentISTDate()} - {shiftName} - (at {getCurrentDateTime1()})
                  </span>
                </div>

                <CustomDataTable data={gvpList} columns={scvReportColumns} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to get default date in "YYYY-MM-DDTHH:MM" format
// const getStartOfCurrentDate = () => {
//   const now = new Date();
//   const year = now.getFullYear();
//   const month = String(now.getMonth() + 1).padStart(2, "0");
//   const day = String(now.getDate()).padStart(2, "0");
//   return `${year}-${month}-${day}T00:00`;
// };

// // Function to get current date and time in the required format
// const getCurrentDateTime = () => {
//   const now = new Date();
//   const year = now.getFullYear();
//   const month = String(now.getMonth() + 1).padStart(2, "0");
//   const day = String(now.getDate()).padStart(2, "0");
//   const hour = String(now.getHours()).padStart(2, "0");
//   const minute = String(now.getMinutes()).padStart(2, "0");
//   return `${year}-${month}-${day}T${hour}:${minute}`;
// };

export default MultiClearenceExistingGvpInnerGvpReport;
